// extracted by mini-css-extract-plugin
export default {"black":"favourite-icon__black___FsKu8","white":"favourite-icon__white___imbHX","icon":"favourite-icon__icon___h5T8e","filledIcon":"favourite-icon__filledIcon___b68X1"};